import React from "react";
import { ReactComponent as QuestsSvg } from "../../assets/icons/quests.svg";

export default function QuestsIcon({ size = 20, className = "" }) {
  return (
    <QuestsSvg
      className={className}
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      style={{
        display: "inline-block",
        verticalAlign: "middle",
      }}
    />
  );
}
